import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, CircularProgress, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const EmailVerification = () => {
  const { uidb64, token } = useParams();
  const { verifyEmail } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      try {
        const response = await verifyEmail(uidb64, token);
        setStatus('success');
        setMessage(response.message);
        // 3秒後自動導向到登入頁面
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (error) {
        setStatus('error');
        setMessage(error.error || '驗證失敗，請稍後再試');
      }
    };

    verify();
  }, [uidb64, token, verifyEmail, navigate]);

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5" gutterBottom>
          電子郵件驗證
        </Typography>

        {status === 'verifying' && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
            <CircularProgress />
            <Typography sx={{ mt: 2 }}>正在驗證您的電子郵件...</Typography>
          </Box>
        )}

        {status === 'success' && (
          <Alert severity="success" sx={{ mt: 2, width: '100%' }}>
            {message}
            <Typography variant="body2" sx={{ mt: 1 }}>
              即將為您導向到登入頁面...
            </Typography>
          </Alert>
        )}

        {status === 'error' && (
          <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
            {message}
          </Alert>
        )}
      </Box>
    </Container>
  );
};

export default EmailVerification; 